import { cloudfrontUrl } from './url'

export function rewriteS3ImageUrls(location, key = null) {
  if (key && cloudfrontUrl) {
    return `${cloudfrontUrl}${key}`
  } else {
    return location
  }
}
